// "Detalhes técnicos" for a failed API request: what the browser saw, with Cloudflare's request id, so a failure can be
// matched in our logs (or shown never to have reached them). Copyable for support.
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { FailureDiag } from '../lib/api.ts';

export const describeDiag = (d: FailureDiag): string =>
  [`${d.method} ${d.path}`, d.status ? `HTTP ${d.status}` : 'HTTP 0', `cf-ray ${d.cfRay ?? '—'}`, d.at].join(' · ');

export function TechDetails({ diag }: { diag: FailureDiag }) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);
  const text = describeDiag(diag);
  const where = diag.status === 0 ? t('tech.noAnswer') : diag.reachedApi ? t('tech.fromApi') : t('tech.beforeApi');
  return (
    <div className="flex flex-col gap-1 rounded-button border border-line bg-line-2 px-3 py-2 text-xs text-body">
      <span className="font-semibold text-ink">{t('tech.title')}</span>
      <span>{where}</span>
      <span className="font-mono break-all tabular" data-testid="tech-details">{text}</span>
      <button
        type="button"
        className="w-fit text-brand underline"
        onClick={() => {
          void globalThis.navigator?.clipboard?.writeText(text).then(() => setCopied(true), () => undefined);
        }}
      >
        {copied ? t('tech.copied') : t('tech.copy')}
      </button>
    </div>
  );
}
